import { ArrowForwardIos, ContentCopy, Delete } from "@mui/icons-material";
import React, { memo } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";
import { SiOpenai } from "react-icons/si";

const MODE = {
  oneshot:   { emoji: "⚡", label: "Gerar texto",         color: "#6366f1", bg: "#ede9fe" },
  permanent: { emoji: "💬", label: "Agente conversacional", color: "#0891b2", bg: "#e0f2fe" },
  temporary: { emoji: "⏱", label: "Temporário",           color: "#d97706", bg: "#fef3c7" },
};

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const cfg = data?.typebotIntegration || {};
  const mode = MODE[cfg.flowMode] || MODE.oneshot;
  const name = cfg.name || "IA sem nome";
  const outputVar = cfg.outputVariable || "ai_response";

  return (
    <div style={{
      backgroundColor: "#fff",
      padding: "8px 10px",
      borderRadius: 8,
      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
      border: `1px solid ${mode.color}44`,
      minWidth: 180,
      position: "relative",
    }}>
      {/* Delete/Copy */}
      <div style={{ position: "absolute", right: 6, top: 6, display: "flex", gap: 5, cursor: "pointer" }}>
        <ContentCopy
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("duplicate"); }}
          sx={{ width: 11, height: 11, color: "#d1d5db" }}
        />
        <Delete
          onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}
          sx={{ width: 11, height: 11, color: "#d1d5db" }}
        />
      </div>

      {/* Input handle */}
      <Handle type="target" position="left" style={{ background: "#9a00ed", width: 18, height: 18, top: "50%", left: -11, cursor: "pointer" }} isConnectable={isConnectable}>
        <ArrowForwardIos sx={{ color: "#fff", width: 10, height: 10, marginLeft: "2.9px", marginBottom: "1px", pointerEvents: "none" }} />
      </Handle>

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 5 }}>
        <SiOpenai style={{ width: 14, height: 14, color: mode.color }} />
        <span style={{ fontSize: 13, fontWeight: 700, color: "#1e293b", maxWidth: 120, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {name}
        </span>
      </div>

      {/* Mode badge */}
      <div style={{ display: "inline-flex", alignItems: "center", gap: 4, backgroundColor: mode.bg, borderRadius: 5, padding: "2px 7px", marginBottom: cfg.flowMode === "oneshot" ? 5 : 0 }}>
        <span style={{ fontSize: 10 }}>{mode.emoji}</span>
        <span style={{ fontSize: 10, fontWeight: 700, color: mode.color }}>{mode.label}</span>
      </div>

      {/* Output variable (oneshot only) */}
      {cfg.flowMode === "oneshot" && (
        <div style={{ backgroundColor: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 4, padding: "2px 7px", fontSize: 10, fontFamily: "monospace", color: "#475569" }}>
          → <strong style={{ color: "#6366f1" }}>{`{${outputVar}}`}</strong>
        </div>
      )}

      {/* Output handle */}
      <Handle type="source" position="right" id="a" style={{ background: "#9a00ed", width: 18, height: 18, top: "50%", right: -11, cursor: "pointer" }} isConnectable={isConnectable}>
        <ArrowForwardIos sx={{ color: "#fff", width: 10, height: 10, marginLeft: "2.9px", marginBottom: "1px", pointerEvents: "none" }} />
      </Handle>
    </div>
  );
});
